import { createReducer } from '@reduxjs/toolkit';

import { AppConfig } from '../../config/configureApp';

import { setConfig } from './config.actions';


export const reducer = createReducer<AppConfig | null>(null, builder => builder
    .addCase(setConfig, (state, action) => action.payload));
